module.exports = __webpack_public_path__ + "static/media/Simborgarmarket10.502054db.png";